import { SequenceConfig } from '../redux/sequence/types';
import store from '../redux/store';
import { routes } from '../routes';
import { getFinalPageText } from '../utils/getter';
import sequenceConditions from './sequence-conditions';

const PrivateSequence = (): SequenceConfig[] => {
  const activeLeaseApplication = store.getState().leaseApp?.activeApplication;
  return sequenceConditions([
    {
      key: 'Selbstauskunft',
      name: 'Selbstauskunft',
      title: 'Erstelle jetzt deinen Antrag',
      subTitle: 'Zunächst fragen wir Dich nach ein paar Angaben über Dich.',
      steps: [
        {
          key: 'personalInformation',
          name: 'Persönliche Daten',
          route: routes.leaseApplication.self_disclosure.personalInformation,
        },
        {
          key: 'kia_flex.workContactBank',
          name: 'Beruf, Kontakt und Bankverbindung',
          route:
            routes.leaseApplication.self_disclosure.kia_flex.workContactBank,
        },
        {
          key: 'kia_flex.dataSummary',
          name: 'Zusammenfassung',
          route: routes.leaseApplication.self_disclosure.kia_flex.dataSummary,
        },
      ],
    },
    {
      key: 'bonitätsprüfung',
      name: 'Bonitätsprüfung',
      title: 'Bonitätsprüfung',
      subTitle:
        'Anschließend starten wir die Bonitätsprüfung - diese kann bis zu zwei Werktagen dauern.',
      steps: [
        {
          key: 'creditCheckB2CStart',
          name: 'Kreditprüfung starten',
          route: routes.leaseApplication.creditCheckB2C.creditCheckB2CStart,
        },
        {
          key: 'creditCheckB2CStatus',
          name: 'Kreditprüfung',
          route: routes.leaseApplication.creditCheckB2C.creditCheckB2CStatus,
        },
      ],
    },
    {
      key: 'identityCheckB2C',
      name: 'Abschluss',
      title: 'Abschluss',
      subTitle:
        'Nutze IDnow für die Online-Identifikation und digitale Signatur. Du hast 14 Tage nach der Bonitätsprüfung Zeit.',
      steps: [
        {
          key: 'reviewContractB2C',
          name: 'Mietvertrag',
          route: routes.leaseApplication.identityCheckB2C.reviewContractB2C,
        },
        {
          key: 'idNowB2C',
          name: 'Identifikation starten',
          route: routes.leaseApplication.identityCheckB2C.idNowB2C,
        },
        {
          key: 'idNowResponse',
          name: 'Identifikation status',
          route: routes.leaseApplication.identityCheckB2C.idNowResponse,
        },
      ],
    },
    {
      key: 'success',
      name: 'Success Message',
      title: getFinalPageText(activeLeaseApplication),
      subTitle:
        'Du hast den Vertrag erfolgreich unterzeichnet und kannst ihn jetzt herunterladen.',
      steps: [],
    },
    {
      key: 'something wrong',
      name: 'Wrong Message',
      title: 'Entschuldigung, da ist etwas schief gelaufen',
      subTitle: '',
      steps: [],
    },
  ]);
};

export default PrivateSequence;
